import React from "react";
import './loader.css';

const Loader = ({ text, small }) => {
  return (
    <div className={`loader-wrapper ${small ? 'small' : ''}`}>
      <div className="loader"></div>
      {!small && text && <span className="loader-text">{text}</span>}
    </div>
  );
};

export default Loader;
